import { IonBackButton, IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonItemDivider, IonItemGroup, IonLabel, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { createOutline, pin, walk, warning, wifi, wine } from 'ionicons/icons';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import CreateHolidays from '../../components/holidays/CreateHolidays';
import ExploreContainer from '../../components/ExploreContainer';
import { CustomRoutes } from '../../utils/CustomRoutes';

const AdminLeavesPage: React.FC = () => {
  const { name } = useParams<{ name: string; }>();
  const history = useHistory();

  const routeChange = (path: string) => {
    history.push(path);
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonGrid>
          <IonRow>
            <IonCol size-md="6" size-sm="12" size-xs="12" size='12'>
              <IonCard>
                <IonItemGroup>
                  <IonItemDivider>
                    <IonLabel color="primary">Types of leaves in Organization</IonLabel>
                  </IonItemDivider>
                  <IonItem>
                    <IonLabel className="w-25">Sick Leaves</IonLabel>
                    <IonLabel className="w-75">5</IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>Casual Leaves</IonLabel>
                    <IonLabel>10</IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>Bereavement leave</IonLabel>
                    <IonLabel>2</IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>Sabbatical leave</IonLabel>
                    <IonLabel></IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>Paid leave</IonLabel>
                    <IonLabel>10</IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>UnPaid leave</IonLabel>
                    <IonLabel>10</IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>Maternity Leave
                      <IonBadge className="mb-2" color="warning">Optional</IonBadge>
                    </IonLabel>
                    <IonLabel>3 Weeks</IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>Paternity leave
                      <IonBadge className="mb-2" color="warning">Optional</IonBadge>
                    </IonLabel>
                    <IonLabel>1 Week</IonLabel>
                  </IonItem>
                </IonItemGroup>
              </IonCard>
            </IonCol>
            {/* <IonCol size-md="6" size-sm="12" size-xs="12" size='12'>
              <IonCard>
                <CreateHolidays name="Create Holidays" editHoliday={''} ></CreateHolidays>
              </IonCard>
            </IonCol> */}
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
export default AdminLeavesPage;